/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { KnobsPanel } from './KnobsPanel';
import { CodePreviewOptions } from './CodePreviewOptions';
import { Knobs } from '../../Docs/DocTypes';
import { KnobValues } from './KnobsUtils';

type CodeTabProps = {
  mobileFriendly: boolean;
  mobileView: boolean;
  codeVisible: boolean;
  backgroundVisible: boolean;
  knobs: Knobs;
  knobValues: KnobValues;
  camelCaseLabels: boolean;
  renderRunningCode: () => JSX.Element;
  renderCode: () => JSX.Element;
  onCodeVisibleChange: (newCodeVisible: boolean) => void;
  onMobileViewChange: (newMobileView: boolean) => void;
  onBackgroundVisibleChange: (newBackgroundVisible: boolean) => void;
  onKnobValuesChange: (newValues: KnobValues) => void;
};

export const CodeTab = (props: CodeTabProps) => {
  const styles = makeStyles();
  return (
    <div css={styles.renderRunningCode}>
      {props.renderRunningCode()}
      <div css={styles.renderCode(props.codeVisible)}>{props.renderCode()}</div>
      {props.knobs && props.codeVisible && (
        <KnobsPanel
          knobs={props.knobs}
          knobValues={props.knobValues}
          onChange={props.onKnobValuesChange}
          camelCaseLabels={props.camelCaseLabels}
        />
      )}
      <CodePreviewOptions
        mobileFriendly={props.mobileFriendly}
        codeVisible={props.codeVisible}
        onCodeVisibleChange={props.onCodeVisibleChange}
        backgroundVisible={props.backgroundVisible}
        onBackgroundVisibleChange={props.onBackgroundVisibleChange}
        mobileView={props.mobileView}
        onMobileViewChange={props.onMobileViewChange}
      />
    </div>
  );
};

const makeStyles = () => {
  return {
    renderRunningCode: css`
      margin-bottom: 15px;
    `,
    renderCode: (codeVisible: boolean) => css`
      margin: 15px 0px 10px 0px;
      padding: 0px;
      background-color: #272822;
      border-radius: 5px;
      display: ${codeVisible ? 'block' : 'none'};
    `,
  };
};
